module.exports = __webpack_public_path__ + "media/icons/pochodzenie-sprowadzony-white-2377ddd1.png";